import { jsx as o, jsxs as g } from "react/jsx-runtime";
import { forwardRef as A, useId as E, useMemo as R, Children as v, useRef as $, useState as j, useEffect as C, useImperativeHandle as L } from "react";
import { t as c } from "../../bundle-mjs-DoW15_-f.js";
import { tabsTheme as K } from "./theme.js";
const M = ({ children: i, className: r }) => /* @__PURE__ */ o("div", { className: r, children: i });
M.displayName = "TabButtons.Item";
const I = A(
  ({
    children: i,
    className: r,
    onActiveTabChange: f,
    variant: u = "default",
    activeTab: b,
    isLoading: T,
    ...k
  }, N) => {
    const a = K, p = E(), h = R(
      () => v.map(
        v.toArray(i),
        ({ props: t }) => t
      ),
      [i]
    ), y = $([]), [s, l] = j(-1), m = (t) => {
      f && f(t);
    }, w = ({ target: t }) => {
      m(t), l(t);
    }, B = ({
      event: t,
      target: e
    }) => {
      t.key === "ArrowLeft" && l(Math.max(0, s - 1)), t.key === "ArrowRight" && l(Math.min(h.length - 1, s + 1)), t.key === "Enter" && (m(e), l(e));
    }, n = a.tablist.tabitem.variant[u];
    return C(() => {
      y.current[s]?.focus();
    }, [s]), L(N, () => ({
      setActiveTab: m
    })), /* @__PURE__ */ o("div", { className: c(a.base, r), children: /* @__PURE__ */ o(
      "div",
      {
        "aria-label": "Tabs",
        role: "tablist",
        className: c(
          a.tablist.base,
          a.tablist.variant[u],
          r
        ),
        ...k,
        children: h.map((t, e) => T ? /* @__PURE__ */ o(
          "div",
          {
            className: c(
              a.tablist.tabitem.base,
              n.base,
              "animate-pulse glass-tile rounded-b-none"
            ),
            children: /* @__PURE__ */ o("span", { style: { visibility: "hidden" }, children: t.title })
          },
          e
        ) : /* @__PURE__ */ g(
          "button",
          {
            type: "button",
            "aria-controls": `${p}-tabpanel-${e}`,
            "aria-selected": e === b,
            className: c(
              a.tablist.tabitem.base,
              n.base,
              e === b && n.active.on,
              e !== b && !t.disabled && n.active.off
            ),
            disabled: t.disabled,
            id: `${p}-tab-${e}`,
            onClick: () => w({ target: e }),
            onKeyDown: (d) => B({ event: d, target: e }),
            onMouseEnter: t.onMouseEnter,
            onMouseLeave: t.onMouseLeave,
            ref: (d) => y.current[e] = d,
            role: "tab",
            tabIndex: e === s ? 0 : -1,
            style: { zIndex: e === s ? 2 : 1 },
            children: [
              t.icon && /* @__PURE__ */ o(
                t.icon,
                {
                  className: a.tablist.tabitem.icon
                }
              ),
              t.title
            ]
          },
          e
        ))
      }
    ) });
  }
);
I.displayName = "TabButtons";
const H = Object.assign(I, {
  Item: M
});
export {
  M as Button,
  H as TabButtons
};
